import React, { useState,useEffect  } from "react";
import "./answer-summary.css";

const AnswerSummary = ({answerSummary,translate})=>{
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 550);
    const [userResponseList, setUserResponseList] = useState(
        Array.from({ length: 40 }, (_, index) => ({
            index: index + 1,
            userResponse: "", // Initialize userResponse as an empty string
        }))
    );

    useEffect(() => {
        const updatedList = [...userResponseList]; // Create a shallow copy of the list
        answerSummary.forEach((response, index) => {
            const targetIndex = index; // Find the corresponding index
            if (updatedList[targetIndex]) {
                updatedList[targetIndex].userResponse = response.userResponse;
            }
        });
        setUserResponseList(updatedList);
    }, [answerSummary]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 550);
            if (window.innerWidth >= 550) {
                setIsOpen(true); // Ensure it's open on larger screens
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            <div className="answer-summary-container">
                {(!isMobile) && <div className="answer-summary-header" >{translate("Answer Summary")}</div>}
                {(isMobile) && <div className="answer-summary-header" onClick={() => isMobile && setIsOpen(!isOpen)} >{translate("Answer Summary")}</div>}
                {(isOpen || !isMobile)&&
                    <>
                        <div className="answer-summary-labels">
                            <div className="green-circle"></div>
                            <span className="label-name">{translate("Correct")}</span>
                            <div className="red-circle"></div>
                            <span className="label-name">{translate("Incorrect")}</span>
                        </div>
                        <div className="answer-summary-questions-list">
                            {userResponseList.map((item) => (
                                <div key={item.index}
                                     className={item.userResponse === "correct" ? "green-circle" : item.userResponse === "incorrect" ? "red-circle" : "circle"}>
                                    {item.index}
                                </div>
                            ))}
                        </div>
                    </>
                }
            </div>
        </>
    );
}

export default AnswerSummary